module.exports = __webpack_public_path__ + "img/scene-1.daf653f.png";